var styleDataHash = "4aa8c346";
const injectCss = () => {
  var css = `@charset "UTF-8";.RABXS,.glob_fontElementMap{font-family:var(--ricos-font-family,unset)}.oML2s{box-sizing:border-box;display:flex;flex-direction:column;gap:8px;max-height:360px;min-height:40px;overflow:hidden;overflow:auto}[dir] .oML2s{background-color:#fff;border-radius:var(--ricos-settings-whitebox-border-radius,2px);box-shadow:var(--ricos-settings-whitebox-box-shadow,0 4px 8px 0 rgba(0,0,0,.1),0 0 4px 0 rgba(0,0,0,.1));padding:8px 0}.oML2s *,.oML2s :after,.oML2s :before{box-sizing:inherit}.oML2s input{box-sizing:border-box}.o91Nx{align-items:center;align-self:center;color:var(--ricos-settings-text-color,var(--ricos-text-color,#212121));display:flex;font-family:var(--ricos-settings-text-font-family,Madefor,"Helvetica Neue",Helvetica,Arial,メイリオ,meiryo,"ヒラギノ角ゴ pro w3","hiragino kaku gothic pro",sans-serif);font-size:14px;gap:12px;justify-content:start;min-height:36px;width:220px}[dir] .o91Nx{cursor:pointer}[dir=ltr] .o91Nx{padding-left:12px;padding-right:8px}[dir=rtl] .o91Nx{padding-left:8px;padding-right:12px}.o91Nx span{overflow:hidden;text-overflow:ellipsis;white-space:nowrap}[dir] .o91Nx.OTNEP{background-color:rgba(var(--ricos-settings-action-color-tuple,var(--ricos-fallback-color-tuple,0,0,0)),.06)}.o91Nx .xLEzk{height:28px;min-height:28px;min-width:28px;overflow:hidden;width:28px}[dir] .o91Nx .xLEzk{border-radius:50%}`;
  var isTest = typeof process !== "undefined" && process.env && false;
  if (isTest || !css || typeof document === "undefined") {
    return;
  }
  if (document.querySelector('style[data-ricos-style-hash="' + styleDataHash + '"]')) {
    return;
  }
  var head = document.head || document.getElementsByTagName("head")[0];
  var style = document.createElement("style");
  style.setAttribute("data-ricos-style-hash", styleDataHash);
  style.type = "text/css";
  head.appendChild(style);
  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
};
injectCss();
var mention_list_default = {
  "fontElementMap": "RABXS",
  "mention_list": "oML2s",
  "mention_item": "o91Nx",
  "mention_item_selected": "OTNEP",
  "avatar": "xLEzk"
};
export {
  mention_list_default as default,
  injectCss
};
//# sourceMappingURL=mention-list-scss.js.map
